import { LearningMaterialSummary } from "shared/request/myHealthyAdvantageApi";
import { ResourceCard } from "UIPalette/ResourceCard/ResourceCard";
import { HorizontalScroll } from "shared/UI/HorizontalScroll/HorizontalScroll";
import { DesktopCarousel } from "UIPalette/DesktopCarousel/DesktopCarousel";
import useIsMobile from "shared/core/hooks/useIsMobile";
import { Breakpoint } from "shared/UI/ResponsiveBreakpoints";
import classNames from "classnames";

const sampleResources: LearningMaterialSummary[] = [
  {
    id: "G60JH94fQymc3nysE5s5JQ",
    title: " Supporting Students’ Health and Wellbeing on Placement",
    articleType: "article",
    duration: 5,
    createdAt: "2025-09-22T11:32:32+00:00",
    image: {
      id: "Sr6c05DlSo-9Nhxvfe07FA",
      title: "",
      url: "https://www.datocms-assets.com/93767/1758540706-1758095144-students_mental_health.webp",
    },
    categories: [
      { id: "131646500", name: "Students" },
      { id: "170998708", name: "Article" },
    ],
  },
  {
    id: "WxCTQRY3RQeU2QWAePGzGg",
    title: "How to Cope with Financial Problems and Stress as a Student",
    articleType: "article",
    duration: 5,
    createdAt: "2025-09-22T11:30:07+00:00",
    image: {
      id: "VmYLC0XsTim0M1lJn8dq0g",
      title: "",
      url: "https://www.datocms-assets.com/93767/1758540580-1731342339-untitled-design-23.webp",
    },
    categories: [
      { id: "131646500", name: "Students" },
      { id: "170998708", name: "Article" },
    ],
  },
  {
    id: "QcY__aCQRbK3PXkQ4tY4OQ",
    title: "Grieving at University or College",
    articleType: "article",
    duration: 4,
    createdAt: "2025-09-22T11:28:30+00:00",
    image: {
      id: "fm4E0C9CSPG6Z9EQ8EKROA",
      title: "",
      url: "https://www.datocms-assets.com/93767/1758540460-1756732123-grief_student_wisdom_wellbeing.webp",
    },
    categories: [
      { id: "131646500", name: "Students" },
      { id: "170998708", name: "Article" },
    ],
  },
  {
    id: "YPot2t4PQvSPGuBtOBAUxQ",
    title: "DE&I: Combating Bias at Work",
    articleType: "article",
    duration: 7,
    createdAt: "2025-09-22T11:24:50+00:00",
    image: {
      id: "FSxHg7trRRiDhaHpW-4YRw",
      title: "",
      url: "https://www.datocms-assets.com/93767/1758540236-1758015563-diversirty-in-the-workplace.webp",
    },
    categories: [
      { id: "170998708", name: "Article" },
      { id: "175415941", name: "Diversity and Equality" },
    ],
  },
];

export default function ComponentsResources() {
  const isMobile = useIsMobile(Breakpoint.Desktop);

  const resourceCards = sampleResources.map((resource) => (
    <ResourceCard key={resource.id} item={resource} className={classNames({ "min-w-[220px]": isMobile })} />
  ));

  return (
    <div className="space-y-8">
      {isMobile ? (
        <HorizontalScroll className="hide-scrollbar">
          <div className="flex gap-6">
            {resourceCards}
            <div className="min-w-[1px] min-h-full"></div>
          </div>
        </HorizontalScroll>
      ) : (
        <DesktopCarousel>{resourceCards}</DesktopCarousel>
      )}
    </div>
  );
}
